import { useTranslation } from 'react-i18next';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';
import UpgradePageLink from '~/components/UpgradePageLink';

import type { Publication } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

import NavGroupContainer from './NavGroupContainer';
import NavGroupListContainer from './NavGroupListContainer';
import ThemedNavGroupLink from './ThemedNavGroupLink';
import ThemedNavGroupTitle from './ThemedNavGroupTitle';

interface Props {
  isPremiumEnabled: boolean;
  isLoggedIn?: boolean;
  isReferralEnabled: boolean;
  publication: Publication;
  subscription?: Subscription;
}

const GeneralNavGroup = ({ isPremiumEnabled, isLoggedIn, isReferralEnabled, publication, subscription }: Props) => {
  const { t } = useTranslation();
  const { webTheme } = useWebThemeContext();

  return (
    <NavGroupContainer>
      <ThemedNavGroupTitle text={t('nav.mobile_sections.account')} />
      <NavGroupListContainer>
        {isPremiumEnabled && (
          <UpgradePageLink href={publication.web_template.external_upgrade_page_href}>
            <Typography
              as="p"
              size={'xs'}
              weight="regular"
              color={webTheme.footer_text_color}
              fontFamilyv2={webTheme.font_body}
            >
              {t('nav.links.upgrade')}
            </Typography>
          </UpgradePageLink>
        )}
        {isLoggedIn && subscription && (
          <ThemedNavGroupLink
            path={`/subscribe/${subscription?.subscriber_id || ''}/manage`}
            text={t('nav.links.manage')}
          />
        )}
        {isReferralEnabled && subscription && (
          <ThemedNavGroupLink
            path={`/subscribe/${subscription?.subscriber_id || ''}/referrals`}
            text={t('nav.links.referrals')}
          />
        )}
      </NavGroupListContainer>
    </NavGroupContainer>
  );
};

export default GeneralNavGroup;
